import { createRoot } from "react-dom/client";
import "../src/app/pro/styles.css";
import "../src/app/pro/core/shell/layout.css";
import { AppRoot } from "../src/app/pro/core/app-root";

if ("serviceWorker" in navigator) {
  const register = () => {
    void navigator.serviceWorker
      .register("/sw.js", { scope: "/" })
      .catch(() => undefined);
  };
  if (document.readyState === "complete") register();
  else window.addEventListener("load", register, { once: true });
}

createRoot(document.getElementById("root")!).render(<AppRoot />);
